export default __webpack_public_path__ + "static/media/3.124fdfb1.svg";